import { useAuth0 } from '@auth0/auth0-react';
import { Loader, Stack, Text, Title } from '@mantine/core';
import { Navigate, useLocation } from 'react-router-dom';
import { Card, CenteredLayout, PrimaryButton } from '../../components';

interface LoginLocationState {
  from?: string;
}

export function LoginContainer() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();
  const from = (location.state as LoginLocationState | null)?.from ?? '/';

  const handleLogin = () => {
    void loginWithRedirect({ appState: { returnTo: from } });
  };

  return isLoading ? (
    <CenteredLayout>
      <Loader />
    </CenteredLayout>
  ) : isAuthenticated ? (
    <Navigate to={from} replace />
  ) : (
    <CenteredLayout>
      <Card sx={{ width: 380 }}>
        <Stack spacing="lg" align="center">
          <Title order={3}>Bagel Admin</Title>
          <Text color="dimmed" size="sm" align="center">
            Sign in to continue.
          </Text>
          <PrimaryButton fullWidth onClick={handleLogin}>
            Log in with Auth0
          </PrimaryButton>
        </Stack>
      </Card>
    </CenteredLayout>
  );
}
